import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Search } from 'lucide-react';
import api from '../services/api';
import ProductCard from '../components/product/ProductCard';

export default function SearchPage() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!query) return;
    setLoading(true);
    api.get('/products', { params: { search: query, per_page: 24 } })
      .then(r => setProducts(r.data.data || r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [query]);

  return (
    <div className="min-h-screen bg-white">
      <div className="border-b border-gray-100 py-10">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center gap-3 mb-2">
            <Search size={20} className="text-gray-400" />
            <h1 className="text-2xl font-serif font-bold text-gray-900">Search Results</h1>
          </div>
          {query && <p className="text-gray-500 text-sm ml-8">Showing results for "<span className="font-medium text-gray-900">{query}</span>"</p>}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        {!query ? (
          <div className="text-center py-20 text-gray-400">Enter a search term to find products.</div>
        ) : loading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {Array(8).fill(null).map((_, i) => <div key={i} className="aspect-[3/4] bg-gray-100 animate-pulse rounded" />)}
          </div>
        ) : products.length === 0 ? (
          <div className="text-center py-20 text-gray-400">No products found for "{query}".</div>
        ) : (
          <>
            <p className="text-sm text-gray-500 mb-6">{products.length} product{products.length !== 1 ? 's' : ''} found</p>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {products.map(p => <ProductCard key={p.id} product={p} />)}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
